/* Produktkarten (snippets/mpb-card-content.liquid):
   1. Hover (nur Geraete mit Maus): Inhaltsbereich faehrt ueber das Bild, Kurzbeschreibung + Aktionsbutton erscheinen.
      Die noetige Hubhoehe wird beim Oeffnen einmal gemessen (--pcc-lift); die Kartenhoehe bleibt unveraendert.
   2. Klick auf freie Kartenflaeche -> Produktseite (Buttons, Links, Herz ausgenommen).
   3. Quick-Add-Pop-up fuer "Variante waehlen" (templates/product.mpb_quickadd.liquid).
   Das Hinzufuegen selbst uebernimmt die Theme-Logik (.js_add_to_cart_button, Ajax-Warenkorb + Drawer).
   Delegierte Listener -> funktioniert auch fuer per AJAX geladene Karten (Slider, Filter, pr_lazy_load). */
(function () {
  if (window.__cbiInit) return;
  window.__cbiInit = true;

  // Hover nur bei echter Maus/Stift-Bewegung. Bewusst kein (hover: hover)-Media-Query: Edge meldet auf
  // Windows-Geraeten mit Touchscreen teils "hover: none", obwohl eine Maus benutzt wird.
  function isMouse(e) { return e.pointerType === 'mouse' || e.pointerType === 'pen'; }

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
      return Shopify.formatMoney(cents, theme.moneyFormat) + ' EUR';
    }
    return '€' + (cents / 100).toFixed(2).replace('.', ',') + ' EUR';
  }
  // Preise in Shopify sind brutto; Karten zeigen netto (/1,19, abgerundet wie die Liquid-Ganzzahldivision der Karten)
  function net(cents) { return Math.round(cents * 100 / 119); } /* 2026-10-30: kaufmaennisch runden wie Produktseite/Warenkorb (vorher abgerundet, 1 Cent Abweichung) */

  /* ---------- 1. Hover ---------- */
  var WIDE = window.matchMedia ? window.matchMedia('(min-width: 768px)') : { matches: true };
  // Hub = Hoehe der aufklappenden Zusatzinfos minus des dabei zuklappenden unteren Pflichthinweises
  function openCard(card) {
    if (!WIDE.matches || card.classList.contains('is-open')) return;
    var more = card.querySelector('.pcc-more__in'), less = card.querySelector('.pcc-less__in');
    var lift = Math.max(0, (more ? more.scrollHeight : 0) - (less ? less.scrollHeight : 0));
    card.style.setProperty('--pcc-lift', lift + 'px');
    card.classList.add('is-open');
  }
  function closeCard(card) { card.classList.remove('is-open'); }

  document.addEventListener('pointerover', function (e) {
    if (!isMouse(e)) return;
    var card = e.target.closest && e.target.closest('.product-collection');
    if (card && !(e.relatedTarget && card.contains(e.relatedTarget))) openCard(card);
  });
  document.addEventListener('pointerout', function (e) {
    if (!isMouse(e)) return;
    var card = e.target.closest && e.target.closest('.product-collection');
    if (card && !(e.relatedTarget && card.contains(e.relatedTarget)) && !card.querySelector(':focus-visible')) closeCard(card);
  });
  document.addEventListener('focusin', function (e) {
    var card = e.target.closest && e.target.closest('.product-collection');
    if (card && e.target.matches(':focus-visible')) openCard(card);
  });
  document.addEventListener('focusout', function (e) {
    var card = e.target.closest && e.target.closest('.product-collection');
    if (card && !(e.relatedTarget && card.contains(e.relatedTarget)) && !card.matches(':hover')) closeCard(card);
  });

  /* ---------- 2. Klick auf die Karte -> Produktseite ---------- */
  // Kein "form": in Karussell-Karten liegt der gesamte Karteninhalt in einem <form> (sonst wirkt der Klick dort nie).
  // Kauf-/Variantenbereich (.cbi) bleibt komplett ausgenommen, auch die Flaechen zwischen den Bedienelementen.
  var INTERACTIVE = 'a, button, select, input, textarea, label, .cbi, .pcc-x--act, .pcc-wish, .product-image__overlay-top-right, [role="button"]';
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    var card = e.target.closest && e.target.closest('.product-collection');
    if (!card || e.target.closest(INTERACTIVE)) return;
    if (card.closest('.list-style')) return;
    if (String(window.getSelection && window.getSelection()) !== '') return;
    var link = card.querySelector('.pcc-title a[href]');
    if (!link) return;
    if (e.ctrlKey || e.metaKey) window.open(link.href, '_blank');
    else window.location.href = link.href;
  });

  /* ---------- 3. Quick-Add-Pop-up ---------- */
  var qa = null, qaBody, qaTrigger, qaCache = {}, qaWatch;

  function qaShell() {
    if (qa) return;
    qa = document.createElement('div');
    qa.className = 'mpb-qa';
    qa.hidden = true;
    qa.innerHTML = '<div class="mpb-qa__backdrop" data-qa-close></div>' +
      '<div class="mpb-qa__dialog" role="dialog" aria-modal="true" aria-labelledby="mpb-qa-title" tabindex="-1">' +
      '<button type="button" class="mpb-qa__close" data-qa-close aria-label="Schließen"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>' +
      '<div class="mpb-qa__body"></div></div>';
    document.body.appendChild(qa);
    qaBody = qa.querySelector('.mpb-qa__body');
    qa.addEventListener('click', function (e) { if (e.target.closest('[data-qa-close]')) qaClose(); });
    document.addEventListener('keydown', function (e) {
      if (qa.hidden) return;
      if (e.key === 'Escape') { qaClose(); return; }
      if (e.key === 'Tab') { // Fokus im Dialog halten
        var f = [].filter.call(qa.querySelectorAll('a[href], button:not([disabled]), select, input'), function (x) { return x.offsetParent; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
  }

  function qaOpen(handle, trigger) {
    qaShell();
    qaTrigger = trigger;
    qaBody.innerHTML = '<div class="mpb-qa__loading" aria-label="Wird geladen"></div>';
    qa.hidden = false;
    document.documentElement.classList.add('mpb-qa-lock');
    requestAnimationFrame(function () { qa.classList.add('is-visible'); });
    qa.querySelector('.mpb-qa__dialog').focus();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var p = qaCache[handle] || (qaCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '?view=mpb_quickadd')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }));
    p.then(function (html) {
      if (qa.hidden) return;
      qaBody.innerHTML = html;
      qaInit(qaBody.querySelector('[data-qa-root]'));
    }).catch(function () {
      delete qaCache[handle];
      qaBody.innerHTML = '<p class="mpb-qa__error">Das Produkt konnte nicht geladen werden. <a href="' + root + 'products/' + encodeURIComponent(handle) + '">Zur Produktseite</a></p>';
    });
  }

  function qaClose() {
    if (!qa || qa.hidden) return;
    clearInterval(qaWatch);
    qa.classList.remove('is-visible');
    document.documentElement.classList.remove('mpb-qa-lock');
    setTimeout(function () { qa.hidden = true; qaBody.innerHTML = ''; }, 200);
    if (qaTrigger && document.contains(qaTrigger)) qaTrigger.focus({ preventScroll: true });
  }

  function qaInit(root) {
    if (!root) return;
    var vs = [];
    try { vs = JSON.parse(root.querySelector('[data-qa-json]').textContent); } catch (e) {}
    var sels = [].slice.call(root.querySelectorAll('[data-qa-opt]'));
    var idInput = root.querySelector('[data-qa-id]');
    var add = root.querySelector('[data-qa-add]');
    var label = root.querySelector('[data-qa-label]');
    var state = root.querySelector('[data-qa-state]');
    var price = root.querySelector('[data-qa-price]');
    var cmp = root.querySelector('[data-qa-cmp]');
    var img = root.querySelector('[data-qa-img]');
    var ids = root.querySelector('[data-qa-ids]');
    var qty = root.querySelector('[data-qa-qty]');
    var form = root.querySelector('form');
    var low = +root.getAttribute('data-qa-low') || 0; // Metafeld guenstigster Preis netto, wie auf der Produktkarte

    function chosen() { return sels.map(function (s) { return s.value; }); }
    function match(sel) {
      return vs.filter(function (v) { return sel.every(function (val, i) { return !val || v.o[i] === val; }); });
    }
    // Werte ohne verfuegbare Kombination kennzeichnen (bleiben waehlbar, Button wird dann gesperrt)
    function markOptions() {
      var sel = chosen();
      sels.forEach(function (s, i) {
        [].forEach.call(s.options, function (o) {
          if (!o.value) return;
          if (!o.dataset.label) o.dataset.label = o.textContent;
          var probe = sel.slice(); probe[i] = o.value;
          var ok = match(probe).some(function (v) { return v.a; });
          o.textContent = o.dataset.label + (ok ? '' : ' – ausverkauft');
        });
      });
    }
    function update() {
      markOptions();
      var sel = chosen();
      var complete = sel.every(Boolean);
      var v = complete ? match(sel)[0] : null;
      var pool = v ? [v] : match(sel);
      if (pool.length) {
        var min = Math.min.apply(null, pool.map(function (x) { return x.p; }));
        var varies = !v && pool.some(function (x) { return x.p !== min; });
        if (low && (vs.length === 1 || (!v && pool.length === vs.length))) price.innerHTML = (vs.length > 1 ? '<span class="pcc-ab">ab </span>' : '') + money(low);
        else price.innerHTML = (varies ? '<span class="pcc-ab">ab </span>' : '') + money(net(min));
        if (v && v.c > v.p) { cmp.textContent = 'statt ' + money(net(v.c)) + ' netto'; cmp.hidden = false; } else cmp.hidden = true;
      }
      if (v && v.i && img) setImg(v.i);
      // Kennnummern nur fuer eine eindeutig gewaehlte Variante; Trenner nur zwischen vorhandenen Angaben
      if (ids && (v || vs.length > 1)) {
        ids.textContent = v ? [['Artikelnummer', v.s], ['EAN', v.e], ['PZN', v.z]]
          .filter(function (x) { return x[1]; }).map(function (x) { return x[0] + ': ' + x[1]; }).join(' | ') : '';
      }
      idInput.value = v ? v.id : '';
      if (v && qty) { qty.min = v.min; qty.step = v.step; if (+qty.value < v.min) qty.value = v.min; }
      var can = !!(v && v.a && v.p <= 100000);
      add.disabled = !can;
      label.textContent = !complete ? 'Bitte Variante wählen' : (!v ? 'Nicht verfügbar' : (!v.a ? 'Ausverkauft' : (v.p > 100000 ? 'Preis auf Anfrage' : 'In den Warenkorb')));
      state.textContent = (v && !v.a) ? 'Diese Variante ist derzeit nicht verfügbar. Über die Produktseite können Sie sich benachrichtigen lassen.' :
        (v && v.p > 100000 ? 'Diese Variante bieten wir auf Anfrage an – bitte über die Produktseite anfragen.' : '');
    }
    function setImg(src) {
      if (!img) return;
      img.src = src;
      root.querySelectorAll('[data-qa-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-qa-thumb') === src); });
    }

    sels.forEach(function (s) { s.addEventListener('change', update); });
    root.querySelectorAll('[data-qa-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { setImg(t.getAttribute('data-qa-thumb')); });
    });
    // Wischen ueber das Bild wechselt wie die Punkte
    var qaMain = root.querySelector('.mpb-qa__main'), qaDots = [].slice.call(root.querySelectorAll('[data-qa-thumb]')), qaX = null;
    if (qaMain && qaDots.length > 1) {
      qaMain.addEventListener('touchstart', function (e) { qaX = e.touches[0].clientX; }, { passive: true });
      qaMain.addEventListener('touchend', function (e) {
        if (qaX === null) return;
        var dx = e.changedTouches[0].clientX - qaX; qaX = null;
        if (Math.abs(dx) < 40) return;
        var cur = qaDots.findIndex(function (t) { return t.classList.contains('is-active'); });
        var nxt = (Math.max(cur, 0) + (dx < 0 ? 1 : -1) + qaDots.length) % qaDots.length;
        setImg(qaDots[nxt].getAttribute('data-qa-thumb'));
      }, { passive: true });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qa-minus], [data-qa-plus]');
      if (!b || !qty) return;
      var step = +qty.step || 1, min = +qty.min || 1;
      qty.value = Math.max(min, (+qty.value || min) + (b.hasAttribute('data-qa-plus') ? step : -step));
    });
    // Enter im Formular nicht nativ absenden, sondern ueber die Theme-Warenkorblogik
    form.addEventListener('submit', function (e) { e.preventDefault(); if (!add.disabled) add.click(); });
    // Nach dem Hinzufuegen (Theme entfernt ajax_loading) Pop-up schliessen, der Warenkorb-Drawer uebernimmt
    add.addEventListener('click', function () {
      clearInterval(qaWatch);
      var t = 0;
      qaWatch = setInterval(function () {
        t += 100;
        if ((t > 300 && !add.classList.contains('ajax_loading')) || t > 10000) { clearInterval(qaWatch); qaClose(); }
      }, 100);
    });
    update();
    var first = sels.filter(function (s) { return !s.value; })[0] || add;
    if (first && !first.disabled) first.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mpb-qa]');
    if (!b) return;
    e.preventDefault();
    qaOpen(b.getAttribute('data-mpb-qa'), b);
  });
})();
